import { useQuery } from "@tanstack/react-query";
import { Building2 } from "lucide-react";
import { trpcClient } from "@/lib/trpc";
import { DetailField } from "@/components/shared/DetailField";
import { EntityLink } from "@/components/shared/EntityLink";

/**
 * Thông tin chung của khách hàng trên phiếu giao (04/11/2026): đủ để đi giao — tên pháp lý, MST, địa chỉ, điện thoại,
 * email, người liên hệ, hình thức / địa chỉ giao mặc định. Chỉ xem, đọc từ hồ sơ khách hàng (sửa ở màn Khách hàng).
 */
export function DeliveryCustomerCard({ customerId }: { customerId?: string | null }) {
  const { data: c, isLoading } = useQuery({
    queryKey: ["delivery-customer-card", customerId],
    enabled: Boolean(customerId),
    queryFn: () => (trpcClient as any).customers.getById.query({ id: customerId }),
  });
  if (!customerId) return null;
  if (isLoading) return <div className="rounded-md border border-dashed px-3 py-2 text-xs text-slate-400">Đang tải thông tin khách hàng...</div>;
  if (!c) return null;
  const dash = (v: any) => (v && String(v).trim() ? String(v) : "—");
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/60 p-3" data-testid="delivery-customer-card">
      <div className="mb-2 flex items-center gap-1.5 text-xs font-semibold text-slate-700">
        <Building2 className="h-3.5 w-3.5 text-slate-500" /> Thông tin khách hàng
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 md:grid-cols-4">
        <DetailField label="Khách hàng" value={<EntityLink entityType="customer" id={c.id} code={c.code} label={c.name} />} />
        <DetailField label="MST" value={dash(c.taxCode)} mono />
        <DetailField label="Điện thoại" value={dash(c.phone)} />
        <DetailField label="Email" value={dash(c.email)} />
        <DetailField label="Người liên hệ" value={dash(c.contactPerson)} />
        <DetailField label="Hình thức giao mặc định" value={dash(c.deliveryMethod)} />
        <DetailField label="Địa chỉ" value={dash(c.address)} />
        <DetailField label="Địa chỉ giao mặc định" value={dash(c.deliveryAddress)} />
        {c.transitAddress ? <DetailField label="Địa chỉ trung chuyển" value={c.transitAddress} /> : null}
      </div>
    </div>
  );
}
